<template>
  <router-link
    to="/"
    class="icon icon-logo"
    @click="eventTrack({ name: 'web_click_home_hashkey' })"
  />
</template>
<script setup lang="ts">
import eventTrack from '@/utils/eventTracking';
</script>
<style lang="scss" scoped>
/* .icon-logo {
    display: inline-block;
    width: 102px;
    height: 26px;

    &::before {
      background: url(@/assets/img/svg/icon-logo-dark.svg) no-repeat center/100% 100%;
    }
} */
</style>
